import { FulfillmentBatchSchema } from "@redotech/redo-model/fulfillments/fulfillment-batch";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getBatchHistory = {
  name: "getBatchHistory" as const,
  input: AdvancedFilterInputSchema.extend({
    pageSize: z.number(),
    pageNumber: z.number(),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    batchHistory: z.array(FulfillmentBatchSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
